import * as R from 'ramda'

export const omitDeep = R.curry((key : string, obj : any) : any => {
  const reducer = R.curry((o : any, s : any, k : string) =>
    k === key ? s : R.assoc( k, R.propIs(Object, k, o) ? omitDeep(key, o[k]) : o[k], s)
  )

  return R.is(Array, obj) ? R.map(omitDeep(key), obj) : (R.is(Object, obj) ? R.reduce(reducer(obj), {}, R.keys(obj)) : obj)
})

